var _g, _g2, _g3, _g4, _g5, _g6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHiddenText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 20,
    viewBox: "0 0 130 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_757_5275)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 3,
    y2: 1,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 10,
    x2: 3,
    y2: 8,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 17,
    x2: 3,
    y2: 15,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 5,
    x2: 7,
    y2: 3,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 12,
    x2: 7,
    y2: 10,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 19,
    x2: 7,
    y2: 17,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 5,
    x2: 15,
    y2: 3,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 12,
    x2: 15,
    y2: 10,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 19,
    x2: 15,
    y2: 17,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 3,
    x2: 11,
    y2: 1,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 10,
    x2: 11,
    y2: 8,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 17,
    x2: 11,
    y2: 15,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y1: 3,
    x2: 19,
    y2: 1,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y1: 10,
    x2: 19,
    y2: 8,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y1: 17,
    x2: 19,
    y2: 15,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_757_5275)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    transform: "translate(22)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25,
    y1: 3,
    x2: 25,
    y2: 1,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25,
    y1: 10,
    x2: 25,
    y2: 8,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25,
    y1: 17,
    x2: 25,
    y2: 15,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 29,
    y1: 5,
    x2: 29,
    y2: 3,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 29,
    y1: 12,
    x2: 29,
    y2: 10,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 29,
    y1: 19,
    x2: 29,
    y2: 17,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 37,
    y1: 5,
    x2: 37,
    y2: 3,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 37,
    y1: 12,
    x2: 37,
    y2: 10,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 37,
    y1: 19,
    x2: 37,
    y2: 17,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 33,
    y1: 3,
    x2: 33,
    y2: 1,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 33,
    y1: 10,
    x2: 33,
    y2: 8,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 33,
    y1: 17,
    x2: 33,
    y2: 15,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 41,
    y1: 3,
    x2: 41,
    y2: 1,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 41,
    y1: 10,
    x2: 41,
    y2: 8,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 41,
    y1: 17,
    x2: 41,
    y2: 15,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_757_5275)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    transform: "translate(44)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47,
    y1: 3,
    x2: 47,
    y2: 1,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47,
    y1: 10,
    x2: 47,
    y2: 8,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47,
    y1: 17,
    x2: 47,
    y2: 15,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 51,
    y1: 5,
    x2: 51,
    y2: 3,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 51,
    y1: 12,
    x2: 51,
    y2: 10,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 51,
    y1: 19,
    x2: 51,
    y2: 17,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 59,
    y1: 5,
    x2: 59,
    y2: 3,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 59,
    y1: 12,
    x2: 59,
    y2: 10,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 59,
    y1: 19,
    x2: 59,
    y2: 17,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 55,
    y1: 3,
    x2: 55,
    y2: 1,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 55,
    y1: 10,
    x2: 55,
    y2: 8,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 55,
    y1: 17,
    x2: 55,
    y2: 15,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 63,
    y1: 3,
    x2: 63,
    y2: 1,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 63,
    y1: 10,
    x2: 63,
    y2: 8,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 63,
    y1: 17,
    x2: 63,
    y2: 15,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_757_5275)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    transform: "translate(66)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 69,
    y1: 3,
    x2: 69,
    y2: 1,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 69,
    y1: 10,
    x2: 69,
    y2: 8,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 69,
    y1: 17,
    x2: 69,
    y2: 15,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 73,
    y1: 5,
    x2: 73,
    y2: 3,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 73,
    y1: 12,
    x2: 73,
    y2: 10,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 73,
    y1: 19,
    x2: 73,
    y2: 17,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 81,
    y1: 5,
    x2: 81,
    y2: 3,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 81,
    y1: 12,
    x2: 81,
    y2: 10,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 81,
    y1: 19,
    x2: 81,
    y2: 17,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 77,
    y1: 3,
    x2: 77,
    y2: 1,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 77,
    y1: 10,
    x2: 77,
    y2: 8,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 77,
    y1: 17,
    x2: 77,
    y2: 15,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 85,
    y1: 3,
    x2: 85,
    y2: 1,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 85,
    y1: 10,
    x2: 85,
    y2: 8,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 85,
    y1: 17,
    x2: 85,
    y2: 15,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_757_5275)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    transform: "translate(88)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 91,
    y1: 3,
    x2: 91,
    y2: 1,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 91,
    y1: 10,
    x2: 91,
    y2: 8,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 91,
    y1: 17,
    x2: 91,
    y2: 15,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 95,
    y1: 5,
    x2: 95,
    y2: 3,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 95,
    y1: 12,
    x2: 95,
    y2: 10,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 95,
    y1: 19,
    x2: 95,
    y2: 17,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 103,
    y1: 5,
    x2: 103,
    y2: 3,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 103,
    y1: 12,
    x2: 103,
    y2: 10,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 103,
    y1: 19,
    x2: 103,
    y2: 17,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 99,
    y1: 3,
    x2: 99,
    y2: 1,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 99,
    y1: 10,
    x2: 99,
    y2: 8,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 99,
    y1: 17,
    x2: 99,
    y2: 15,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 107,
    y1: 3,
    x2: 107,
    y2: 1,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 107,
    y1: 10,
    x2: 107,
    y2: 8,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 107,
    y1: 17,
    x2: 107,
    y2: 15,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_757_5275)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    transform: "translate(110)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 113,
    y1: 3,
    x2: 113,
    y2: 1,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 113,
    y1: 10,
    x2: 113,
    y2: 8,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 113,
    y1: 17,
    x2: 113,
    y2: 15,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 117,
    y1: 5,
    x2: 117,
    y2: 3,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 117,
    y1: 12,
    x2: 117,
    y2: 10,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 117,
    y1: 19,
    x2: 117,
    y2: 17,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 125,
    y1: 5,
    x2: 125,
    y2: 3,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 125,
    y1: 12,
    x2: 125,
    y2: 10,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 125,
    y1: 19,
    x2: 125,
    y2: 17,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 121,
    y1: 3,
    x2: 121,
    y2: 1,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 121,
    y1: 10,
    x2: 121,
    y2: 8,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 121,
    y1: 17,
    x2: 121,
    y2: 15,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 129,
    y1: 3,
    x2: 129,
    y2: 1,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 129,
    y1: 10,
    x2: 129,
    y2: 8,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 129,
    y1: 17,
    x2: 129,
    y2: 15,
    stroke: "#F46857",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_757_5275"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_757_5275"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(22)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_757_5275"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(44)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_757_5275"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(66)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_757_5275"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(88)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_757_5275"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(110)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiddenText);
export default __webpack_public_path__ + "static/media/Hidden Text.2af39efaad62b543d198d59ec43ccd0a.svg";
export { ForwardRef as ReactComponent };